var React = require('react');

function Tiktok (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"currentColor","stroke":"none","data-name":"Icon simple-tiktok","d":"M11.5.017C12.587,0,13.671.008,14.754,0a5.191,5.191,0,0,0,1.458,3.475,5.877,5.877,0,0,0,3.534,1.492V8.326a8.921,8.921,0,0,1-3.5-.808,10.3,10.3,0,0,1-1.35-.775c-.008,2.434.008,4.867-.017,7.292a6.366,6.366,0,0,1-1.125,3.284,6.209,6.209,0,0,1-4.926,2.675,6.077,6.077,0,0,1-3.4-.858,6.285,6.285,0,0,1-3.042-4.759c-.017-.417-.025-.833-.008-1.242A6.274,6.274,0,0,1,9.654,7.567c.017,1.233-.033,2.467-.033,3.7a2.86,2.86,0,0,0-3.65,1.767,3.306,3.306,0,0,0-.117,1.342A2.836,2.836,0,0,0,8.77,16.768a2.8,2.8,0,0,0,2.309-1.342,1.923,1.923,0,0,0,.342-.883c.083-1.492.05-2.975.058-4.467.008-3.359-.008-6.709.017-10.059Z","transform":"translate(-2.369)"}));
}

Tiktok.defaultProps = {"width":"17.378","height":"20.002","viewBox":"0 0 17.378 20.002"};

module.exports = Tiktok;

Tiktok.default = Tiktok;
